module.exports = __webpack_public_path__ + "img/major.83ba1ccf.png";